import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=286d2e53&scoped=true"
import script from "./Coaches.vue?vue&type=script&lang=js"
export * from "./Coaches.vue?vue&type=script&lang=js"
import style0 from "./Coaches.vue?vue&type=style&index=0&id=286d2e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d2e53",
  null
  
)

export default component.exports